
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlD as ObiOwnShipControlDElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-d.js';
 
 
 

 
 export const ObiOwnShipControlD = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-d',
   elementClass: ObiOwnShipControlDElement,
   events: {
     
   }
  });
 
 